<header class="header">
  <a
    routerLink="/clients"
    class="header__logo"
  >
    <img
      alt=""
      width="119"
      height="34"
      src="/assets/images/logo.svg"
    />
  </a>

  <app-navigation-menu
    class="header__nav"
    [items]="navLinks"
  />

  <div class="header__user">
    <span class="profile-menu">{{ authUser()?.email }}</span>

    <button
      app-button
      size="large"
      variant="secondary-outlined"
      [loading]="isLoggingOut()"
      (click)="logout()"
    >
      <svg
        appButtonIcon
        icon="logout"
      />
      Logout
    </button>
  </div>
</header>
